import { isUndefined } from 'lodash'

const allReplace = (string, regex, newString) => {
	if (isUndefined(string)) return
	const reg = new RegExp(regex, 'g')
	return string.replace(reg, newString)
}

export default allReplace
